import React from 'react';
import { motion } from 'framer-motion';

export default function PrivacyPolicy() {
  React.useEffect(() => {
    document.title = 'Soon. — Privacy Policy';
  }, []);

  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-3xl mx-auto w-full py-8 md:py-16"
    >
      <header className="mb-16">
        <h1 className="font-serif italic text-4xl md:text-5xl text-brand-cream mb-4">
          Privacy Policy for Soon.
        </h1>
        <p className="font-mono uppercase tracking-[0.15em] text-sm text-brand-dim">
          Last updated: 24 June 2026
        </p>
      </header>

      <div className="prose-custom">
        <p>
          Soon. ("the app") is a countdown app published by Sussex Endocrine
          Clinic ("we", "us"). This policy explains what the app does and does
          not do with your information. The short version: Soon. collects
          nothing. Everything you create stays on your device.
        </p>

        <h2>What we collect</h2>
        <p>
          Nothing. Soon. has no accounts, no sign in, no servers, and no
          analytics. We do not collect, transmit, sell, or share any personal
          information. The developer never receives your data because the app
          never sends it anywhere.
        </p>

        <h2>What stays on your device</h2>
        <p>
          The countdowns you create, your settings, and your chosen styles are
          saved locally in the app&apos;s own storage on your phone. This data
          never leaves your device. If you delete the app, this data is removed
          with it.
        </p>

        <h2>Permissions the app may request</h2>
        <p>
          Soon. only requests a permission at the moment you use a feature that
          needs it. Each one is processed entirely on your device:
        </p>

        <ul>
          <li>
            <strong>Calendar:</strong> so you can pick existing calendar events
            to count down to.
          </li>
          <li>
            <strong>Contacts:</strong> so you can pick contact birthdays to
            count down to.
          </li>
          <li>
            <strong>Reminders (iOS):</strong> so you can import reminders as
            countdowns.
          </li>
          <li>
            <strong>Notifications:</strong> so the app can remind you locally
            before a countdown ends. Notifications are scheduled on your
            device, not through any server.
          </li>
        </ul>

        <p>
          You can decline any permission, and you can change these choices at
          any time in your device settings. Declining a permission only
          disables the feature that needs it.
        </p>

        <h2>Children</h2>
        <p>
          Soon. does not collect data from anyone, including children. The app
          is suitable for all ages.
        </p>

        <h2>Changes to this policy</h2>
        <p>
          If this policy ever changes, the updated version will be posted at
          this address with a new &quot;last updated&quot; date.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about this policy or the app can be sent to{' '}
          <a href="mailto:sussexendocrineclinic@gmail.com">
            sussexendocrineclinic@gmail.com
          </a>
          .
        </p>
      </div>
    </motion.article>
  );
}